import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/subcategory/importer/subcategoryImporterActions'

export default importerReducers(actions)
